import { keyBy } from 'lodash';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from './plans.actions';
import { extractErrorAndShowToast } from '../../../utils/helpers/extractErrorAndShowToast';
import { plansApi } from '../../../services/api/resources/plans/plans.resource';

function* getPlans() {
  try {
    const { data }: AxiosResponse<{ plans: Plan[] }> = yield call(() =>
      plansApi.getAll({ only_customer_plans: true })
    );
    yield put(actions.getPlansSuccess(keyBy(data.plans, 'id')));
  } catch (e: unknown) {
    const err = e as { response?: { data: string } };

    if (err?.response) {
      const { data } = err.response;
      yield put(actions.getPlansFailure(data));
      extractErrorAndShowToast(err);
    }
  }
}

function* planSaga() {
  yield takeLatest('GET_PLANS_REQUEST', getPlans);
}

export default planSaga;
